import axios, { AxiosRequestConfig } from 'axios';
import { isPublicLegalPath } from 'utils/legal';
import { announceSignOut, clearSessionData, hasSession, refreshAccessToken } from 'utils/session';

const axiosServices = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080/v2/' });

export const onSignedOutPage = () =>
  window.location.href.includes('/login') ||
  window.location.href.includes('/reset-password') ||
  window.location.href.includes('/forgot-password') ||
  window.location.href.includes('/complete-profile') ||
  isPublicLegalPath();

axiosServices.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config: any = error.config;
    if (error.response?.status === 401 && !onSignedOutPage()) {
      // The 15-minute access token lapsed: renew it once and replay the request. A
      // session the server has ended (SESSION_EXPIRED) is not renewable.
      const sessionEnded = error.response?.data?.code === 'SESSION_EXPIRED';
      if (!sessionEnded && config && !config._sessionRetried && hasSession()) {
        config._sessionRetried = true;
        const token = await refreshAccessToken();
        if (token) {
          config.headers = config.headers ?? {};
          config.headers.Authorization = `Bearer ${token}`;
          return axiosServices(config);
        }
      }
      // Never leave a dead session's tokens or user data behind.
      if (hasSession()) {
        await clearSessionData('expired');
        announceSignOut('expired');
      }
      window.location.pathname = '/login';
    }
    return Promise.reject((error.response && error.response.data) || 'Wrong Services');
  }
);

export default axiosServices;

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.get(url, { ...config });
console.log("Response data:", res.data);
  return res.data;
};
